import { FC } from 'react';
import { type Project } from '@teachur/http-client';

interface ProjectSelectorProps {
  projects: Project[];
  selectedProjectId: number | null;
  onSelectProject: (project: Project) => void;
}

export const ProjectSelector: FC<ProjectSelectorProps> = ({
  projects,
  selectedProjectId,
  onSelectProject,
}) => {
  if (projects.length <= 1) return null;

  return (
    <div className="flex flex-col gap-2">
      <h5 className="[font-size:var(--fs-h5)]! font-bold text-(--neutral-black-NB900)! m-0!">
        Select Project
      </h5>
      <div className="flex flex-col gap-4">
        {projects.map((project) => (
          <button
            key={project.id}
            onClick={() => onSelectProject(project)}
            className={`flex items-start gap-3 border-2 rounded-lg text-left transition-colors disabled:opacity-50 cursor-pointer ${
              selectedProjectId === project.id
                ? 'border-(--primary-O900) bg-(--primary-O50)'
                : 'border-(--neutral-black-NB100) hover:border-(--primary-O900)'
            }`}
          >
            <div
              className={`flex items-center justify-center w-5 h-5 min-w-5 min-h-5 rounded-full border-2 shrink-0 ${
                selectedProjectId === project.id
                  ? 'border-(--primary-O900) bg-(--primary-O900)'
                  : 'border-(--neutral-black-NB400)'
              }`}
            >
              {selectedProjectId === project.id && (
                <div className="w-2 h-2 rounded-full bg-(--neutral-white-NW1000)" />
              )}
            </div>
            <div className="flex-1">
              <p className="[font-size:var(--fs-p3)]! text-(--neutral-black-NB1000)! font-medium m-0!">
                {project.name || 'Untitled Project'}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
